<!--Translated-->
<template>
  <tbody :class="`tbl-color--${category.class}`">
    <template v-for="(item, index) in displayItems">
      <tr
        class="row"
        v-if="item.type === 'product'"
        :class="{ 'tbl_row--active': getSelectedState(item.data) }"
        :key="item.data.id"
      >
        <td
          class="tbl-cellproblem"
          v-if="index === 0"
          :rowspan="totalRowsCount"
        >
          <div :class="phase.is_temporary ? 'cellproblem-inner' : ''">
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div v-svg="{ name: category.icon }"></div>
                <HoverTooltip
                  :images="images"
                  :header="pest.name"
                  :text="pest.description"
                  :link="pest.link"
                  :noSubstance="true"
                />
              </div>
              <div class="tbl_info-celltext">{{ pest.name }}</div>
            </div>
            <Button
              v-if="phase.is_temporary && products.length >= 2"
              :text="$t('DefenseCombinations:Button')"
              size="h-micro"
              color="accentlines"
              icon="plus"
              @click="addCombination"
            />
          </div>
        </td>
        <td class="tbl-cellproduct" colspan="2">
          <div class="tbl_info">
            <div class="tbl_info-wrap" style="display: flex">
              <div v-if="!phase.is_temporary" class="tbl_checkboxproduct">
                <CheckBox
                  color-checked="accentfill"
                  color-un-checked="gray"
                  @input="onChange(item.data)"
                  :value="getSelectedState(item.data)"
                />
              </div>
              <div
                v-else-if="item.data.is_active"
                v-svg="{ name: 'info' }"
              ></div>
              <div
                id="force-red"
                v-if="!item.data.is_active"
                v-svg="{ name: 'warningtriangle' }"
              />
              <UserHoverTooltipProductDefence
                :product="item.data"
                :noSubstance="true"
              />
            </div>
            <div
              class="tbl_info-celltext"
              @click="!phase.is_temporary && onChange(item.data)"
              :style="calcProductNameStyle(item.data)"
            >
              {{ item.data.name }}
            </div>
          </div>
        </td>
        <td v-if="!phase.is_temporary" class="tbl-cellinpt">
          <div
            class="quantity-display"
            :class="{
              'quantity-display--override': hasQuantityOverride(item.data),
            }"
          >
            <span v-if="hasQuantityOverride(item.data)" class="quantity-old">
              <s>{{ getTemplateQuantity(item.data) }}</s>
            </span>
            <span class="quantity-current">
              {{ pestsProductsAsMap[item.data.id] }}
            </span>
          </div>
        </td>
        <td v-else class="tbl-cellinpt">
          <InputNumber
            class="inputintable"
            label="-"
            :value="getTempProductDisplayValue(item.data)"
            @input="onInput(item.data, $event)"
            :state="getTempProductInputState(item.data)"
            :inptwrapClass="
              isTempProductPristine(item.data) ? 'temp-input--pristine' : ''
            "
            :disableCompletedClass="isTempProductPristine(item.data)"
          />
        </td>
        <td class="tbl-cellprice">
          {{
            item.data.picking
              ? (
                  (item.data.price / item.data.picking) *
                  getEffectiveQuantity(item.data)
                ).toFixed(2)
              : '0.00'
          }}
        </td>
        <td
          class="col-delete"
          v-if="index === 0 && phase.is_temporary"
          :rowspan="totalRowsCount"
          @click="$emit('deletePest', pest.id)"
        >
          <div v-svg="{ name: 'delete' }"></div>
        </td>
      </tr>

      <template v-else-if="item.type === 'combination'">
        <template v-if="phase.is_temporary">
          <tr
            v-if="index > 0"
            class="row row--combination-spacer"
            :key="'combo-spacer-' + item.id"
          >
            <td colspan="5"></td>
          </tr>

          <tr
            class="row tbl_row--active row--combination"
            :key="'combo-header-' + item.id"
          >
            <th
              v-if="index === 0"
              class="tbl-cellproblem"
              :rowspan="totalRowsCount"
            >
              <div class="cellproblem-inner">
                <div class="tbl_info">
                  <div class="tbl_info-wrap">
                    <div v-svg="{ name: category.icon }"></div>
                    <HoverTooltip
                      :images="images"
                      :header="pest.name"
                      :text="pest.description"
                      :link="pest.link"
                      :noSubstance="true"
                    />
                  </div>
                  <div class="tbl_info-celltext">{{ pest.name }}</div>
                </div>
                <Button
                  v-if="products.length >= 2"
                  :text="$t('DefenseCombinations:Button')"
                  size="h-micro"
                  color="accentlines"
                  icon="plus"
                  @click="addCombination"
                />
              </div>
            </th>
            <th class="combination-header-cell" colspan="4">
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: 'combinationpuzzle' }"></div>
                  <AppInput
                    :value="item.comment"
                    @input="updateComboComment(item.id, $event)"
                    class="inputintable inputintable--comment"
                    type="text"
                    :placeholder="$t('DefenseCombinations:CommentPlaceholder')"
                  />
                </div>
                <div
                  class="combination-header-delete"
                  @click="removeCombination(item.id)"
                >
                  <div v-svg="{ name: 'delete' }"></div>
                </div>
              </div>
            </th>
          </tr>

          <tr
            v-for="(comboProd, cIdx) in item.products"
            :key="'combo-prod-' + item.id + '-' + comboProd._comboProductId"
            class="row tbl_row--active row--combination"
          >
            <td
              v-if="cIdx === 0"
              class="col-add"
              :rowspan="item.products.length"
              @click="openComboAddModal(item.id)"
            >
              <div v-svg="{ name: 'plus2' }"></div>
            </td>
            <td
              class="tbl-cellproduct"
              :class="{ 'tbl-cellproduct--grey': !comboProd.quantity }"
            >
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div
                    id="force-red"
                    v-if="!comboProd.is_active"
                    v-svg="{ name: 'warningtriangle' }"
                  />
                  <div v-else v-svg="{ name: 'info' }"></div>
                  <UserHoverTooltipProductDefence
                    :product="comboProd"
                    :noSubstance="true"
                  />
                </div>
                <div class="tbl_info-celltext">{{ comboProd.name }}</div>
                <div
                  class="combination-inline-delete"
                  @click="removeComboProduct(comboProd._comboProductId)"
                >
                  <div v-svg="{ name: 'delete' }"></div>
                </div>
              </div>
            </td>
            <td class="tbl-cellinpt">
              <InputNumber
                class="inputintable"
                label="-"
                :value="getTempComboProductDisplayValue(comboProd)"
                @input="onComboProductInput(comboProd._comboProductId, $event)"
                :state="getTempComboProductInputState(comboProd)"
                :inptwrapClass="
                  isTempComboProductPristine(comboProd)
                    ? 'temp-input--pristine'
                    : ''
                "
                :disableCompletedClass="isTempComboProductPristine(comboProd)"
              />
            </td>
            <td class="tbl-cellprice">
              {{
                comboProd.picking && comboProd.quantity
                  ? (
                      (comboProd.price / comboProd.picking) *
                      comboProd.quantity
                    ).toFixed(2)
                  : '0.00'
              }}
            </td>
          </tr>

          <tr
            v-if="item.products.length === 0"
            class="row tbl_row--active row--combination"
            :key="'combo-empty-' + item.id"
          >
            <td
              v-if="index === 0"
              class="tbl-cellproblem"
              :rowspan="totalRowsCount"
            >
              <div class="cellproblem-inner">
                <div class="tbl_info">
                  <div class="tbl_info-wrap">
                    <div v-svg="{ name: category.icon }"></div>
                    <HoverTooltip
                      :images="images"
                      :header="pest.name"
                      :text="pest.description"
                      :link="pest.link"
                      :noSubstance="true"
                    />
                  </div>
                  <div class="tbl_info-celltext">{{ pest.name }}</div>
                </div>
                <Button
                  v-if="products.length >= 2"
                  :text="$t('DefenseCombinations:Button')"
                  size="h-micro"
                  color="accentlines"
                  icon="plus"
                  @click="addCombination"
                />
              </div>
            </td>
            <td
              class="col-add combination-col-add"
              @click="openComboAddModal(item.id)"
            >
              <div v-svg="{ name: 'plus2' }"></div>
            </td>
            <td
              class="tbl-cellproduct"
              colspan="4"
              style="text-align: center; color: #999"
            >
              {{ $t('DefenseCombinations:MinProducts') }}
            </td>
          </tr>
        </template>

        <template v-else>
          <tr
            v-for="(comboProd, cIdx) in item.products"
            :key="'combo-prod-' + item.id + '-' + comboProd._comboProductId"
            class="row row--combination"
            :class="{ 'tbl_row--active': item.is_selected }"
          >
            <td
              class="tbl-cellproblem"
              v-if="index === 0 && cIdx === 0"
              :rowspan="totalRowsCount"
            >
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: category.icon }"></div>
                  <HoverTooltip
                    :images="images"
                    :header="pest.name"
                    :text="pest.description"
                    :link="pest.link"
                    :noSubstance="true"
                  />
                </div>
                <div class="tbl_info-celltext">{{ pest.name }}</div>
              </div>
            </td>

            <td
              class="col-add tbl-cellproduct"
              v-if="cIdx === 0"
              :rowspan="item.products.length"
              style="padding-left: 0"
            >
              <div class="tbl_info">
                <div
                  class="tbl_info-wrap tooltip-trigger"
                  style="
                    display: flex;
                    justify-content: center;
                    gap: 0;
                    position: relative;
                  "
                >
                  <div class="tbl_checkboxproduct">
                    <CheckBox
                      color-checked="accentfill"
                      color-un-checked="gray"
                      @input="onComboChange(item)"
                      :value="item.is_selected"
                    />
                  </div>
                  <HoverTooltip v-if="item.comment" :text="item.comment" />
                </div>
              </div>
            </td>

            <td class="tbl-cellproduct">
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div
                    id="force-red"
                    v-if="!comboProd.is_active"
                    v-svg="{ name: 'warningtriangle' }"
                  />
                  <div
                    class="tbl_info-celltext"
                    :style="
                      calcProductNameStyle(comboProd, true, item.is_selected)
                    "
                  >
                    {{ comboProd.name }}
                  </div>
                  <UserHoverTooltipProductDefence
                    :product="comboProd"
                    :noSubstance="true"
                  />
                </div>
              </div>
            </td>

            <td class="tbl-cellinpt">
              <div
                class="quantity-display"
                :class="{
                  'quantity-display--override': hasComboQuantityOverride(
                    comboProd._comboProductId
                  ),
                }"
              >
                <span
                  v-if="hasComboQuantityOverride(comboProd._comboProductId)"
                  class="quantity-old"
                >
                  <s>{{
                    getComboTemplateQuantity(comboProd._comboProductId)
                  }}</s>
                </span>
                <span class="quantity-current">
                  {{ comboProd.quantity }}
                </span>
              </div>
            </td>
            <td class="tbl-cellprice">
              {{
                comboProd.picking && comboProd.quantity
                  ? (
                      (comboProd.price / comboProd.picking) *
                      comboProd.quantity
                    ).toFixed(2)
                  : '0.00'
              }}
            </td>
          </tr>

          <tr
            v-if="item.products.length === 0"
            class="row tbl_row--active row--combination"
            :key="'combo-empty-' + item.id"
          >
            <td
              class="tbl-cellproblem"
              v-if="index === 0"
              :rowspan="totalRowsCount"
            >
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: category.icon }"></div>
                  <HoverTooltip
                    :images="images"
                    :header="pest.name"
                    :text="pest.description"
                    :link="pest.link"
                    :noSubstance="true"
                  />
                </div>
                <div class="tbl_info-celltext">{{ pest.name }}</div>
              </div>
            </td>
            <td class="col-add tbl-cellproduct">
              <div class="tbl_info">
                <div class="tbl_info-wrap tooltip-trigger">
                  <div class="tbl_checkboxproduct">
                    <CheckBox
                      color-checked="accentfill"
                      color-un-checked="gray"
                      @input="onComboChange(item)"
                      :value="item.is_selected"
                    />
                  </div>
                  <HoverTooltip v-if="item.comment" :text="item.comment" />
                </div>
              </div>
            </td>
            <td class="tbl-cellproduct" colspan="2" style="text-align: center">
              {{ $t('DefenseCombinations:NoProducts') }}
            </td>
            <td class="tbl-cellprice">0.00</td>
          </tr>
        </template>
      </template>
    </template>

    <tr v-if="displayItems.length === 0" class="row tbl_row--active">
      <td class="tbl-cellproblem" rowspan="1">
        <div :class="phase.is_temporary ? 'cellproblem-inner' : ''">
          <div class="tbl_info">
            <div class="tbl_info-wrap">
              <div v-svg="{ name: category.icon }"></div>
              <HoverTooltip
                :images="images"
                :header="pest.name"
                :text="pest.description"
                :link="pest.link"
                :noSubstance="true"
              />
            </div>
            <div class="tbl_info-celltext">{{ pest.name }}</div>
          </div>
          <Button
            v-if="phase.is_temporary && products.length >= 2"
            :text="$t('DefenseCombinations:Button')"
            size="h-micro"
            color="accentlines"
            icon="plus"
            @click="addCombination"
          />
        </div>
      </td>
      <td
        class="tbl-cellproduct"
        :colspan="phase.is_temporary ? 5 : 4"
        style="text-align: center"
      >
        {{ $t('ProgramRowPest:NoData') }}
      </td>
    </tr>

    <tr class="tablelinedecor">
      <td :colspan="phase.is_temporary ? 6 : 5"></td>
    </tr>

    <DefenseAddProductModal
      v-if="showAddModal"
      :productsList="availableProductsToAdd"
      :alreadyAdded="alreadyAddedProductsIds"
      @save="addProduct"
      @close="
        showAddModal = false;
        activeCombinationId = null;
      "
    />

    <ModalSelectionConflict
      v-if="conflictModal.show"
      :productNames="conflictModal.productNames"
      :isCombination="conflictModal.isCombination"
      @confirm="onConflictConfirm"
      @cancel="onConflictCancel"
    />
  </tbody>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import { mutationTypes } from '@/store/modules/clientsArea/programs';
import InputNumber from '@/components/views/wrappers/InputNumberWithCast';
import CheckBox from '@/components/CheckBox';
import HoverTooltip from '@/pages/programs/components/HoverTooltip';
import { mapPestCategoryToProductCategory } from '@/pages/programs/components/mapCategoryToPest';
import Button from '@/components/views/Button';
import DefenseAddProductModal from '@/pages/programs/components/DefenseAddProductModal';
import ModalSelectionConflict from '@/components/modals/ModalSelectionConflict';
import AppInput from '@/components/views/Input.vue';
import UserHoverTooltipProductDefence from '@/pages/userproject/userPrograms/userDefenceComponents/HoverTooltipProduct';

export default {
  name: 'UserProgramRowPest',
  components: {
    AppInput,
    Button,
    DefenseAddProductModal,
    ModalSelectionConflict,
    InputNumber,
    HoverTooltip,
    CheckBox,
    UserHoverTooltipProductDefence,
  },
  props: {
    phase: { type: Object, required: true },
    pest: { type: Object, required: true },
  },
  data() {
    return {
      showAddModal: false,
      activeCombinationId: null,
      conflictModal: {
        show: false,
        productNames: [],
        isCombination: false,
        onConfirm: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'plantsCareProductsAsMap',
      'udPestsProductsAsMap',
      'udIsProgramProductSelectionBlocked',
      'udIsProgramCombinationSelectionBlocked',
      'udGetProgramProductSelectionConflicts',
      'udGetProgramCombinationSelectionConflicts',
    ]),
    ...mapState({
      isSaving: (state) => state.userDefence.isSaving,
      productsPestsSubcategories: (state) =>
        state.products.productsPestsSubcategories,
      category(state) {
        return state.products.productsPestsSubcategories.find(
          ({ id }) =>
            id === mapPestCategoryToProductCategory(this.pest.category_id)
        );
      },
      products(state) {
        return state.userDefence.productsPests
          .filter(({ pest_id }) => pest_id === this.pest.id)
          .map(({ product_id }) => this.plantsCareProductsAsMap[product_id])
          .filter(Boolean)
          .filter(
            (product) =>
              product.is_active ||
              state.userDefence.programPestsProducts.some(
                (p) =>
                  p.product_id === product.id &&
                  this.getEffectiveQuantityByRecord(p) > 0 &&
                  (p.is_selected ||
                    state.userDefence.serverData.programPestsProducts.find(
                      ({ id }) => id === p.id
                    )?.is_selected)
              )
          );
      },
      programPestsProducts: (state) => state.userDefence.programPestsProducts,
      images(state) {
        const cultureId = state.userDefence.program.culture_id;
        const hasImagesBindedToCulture = state.userDefence.images.some(
          (img) => img.meta_id === cultureId
        );

        return state.userDefence.images
          .filter(
            (img) =>
              img.object_id === this.pest.id &&
              img.type === 0 &&
              (hasImagesBindedToCulture ? cultureId === img.meta_id : true)
          )
          .sort((a, b) => a.meta_id - b.meta_id);
      },
    }),
    pestsProductsAsMap() {
      const getValueById = (id) =>
        this.udPestsProductsAsMap[
          `phase_${this.phase.id}_pest_${this.pest.id}_product_${id}`
        ] &&
        this.getEffectiveQuantityByRecord(
          this.udPestsProductsAsMap[
            `phase_${this.phase.id}_pest_${this.pest.id}_product_${id}`
          ]
        );
      return Object.fromEntries(
        this.productsFiltered.map((p) => [p.id, getValueById(p.id) ?? ''])
      );
    },
    productsFiltered() {
      const products = this.programPestsProducts
        .filter(
          (p) =>
            p.pest_id === this.pest.id && p.program_phase_id === this.phase.id
        )
        .map((p) => p.product_id);
      return this.products.filter((p) => products.includes(p.id));
    },
    combinations() {
      const combos =
        this.$store.state.userDefence.programPestsCombinations.filter(
          (c) =>
            c.program_phase_id === this.phase.id && c.pest_id === this.pest.id
        );
      const comboProducts =
        this.$store.state.userDefence.programPestsCombinationsProducts;
      return combos
        .map((c) => ({
          type: 'combination',
          id: c.id,
          is_selected: c.is_selected,
          comment: c.comment,
          products: comboProducts
            .filter((p) => p.combination_id === c.id)
            .map((p) => ({
              ...p,
              ...(this.plantsCareProductsAsMap[p.product_id] || {}),
              _comboProductId: p.id,
              quantity: this.getEffectiveQuantityByRecord(p),
            })),
        }))
        .filter((combo) => this.shouldShowCombination(combo));
    },
    displayItems() {
      const items = [];
      this.productsFiltered.forEach((p) => {
        items.push({ type: 'product', data: p });
      });
      this.combinations.forEach((c) => {
        items.push(c);
      });
      return items;
    },
    totalRowsCount() {
      if (this.phase.is_temporary) {
        return (
          this.displayItems.reduce((acc, item, index) => {
            if (item.type === 'combination') {
              const rowsForProducts =
                item.products.length > 0 ? item.products.length : 1;
              const spacerRow = index > 0 ? 1 : 0;
              return acc + spacerRow + 1 + rowsForProducts;
            }
            return acc + 1;
          }, 0) || 1
        );
      }
      return (
        this.displayItems.reduce((acc, item) => {
          if (item.type === 'combination') return acc + item.products.length;
          return acc + 1;
        }, 0) || 1
      );
    },
    alreadyAddedProductsIds() {
      if (!this.activeCombinationId) return [];
      const combo = this.combinations.find(
        (c) => c.id === this.activeCombinationId
      );
      return combo ? combo.products.map((p) => p.product_id) : [];
    },
    availableProductsToAdd() {
      return this.products;
    },
    tempActiveProductCounts() {
      const counts = {};

      this.productsFiltered.forEach((product) => {
        const quantity = this.getEffectiveQuantityByRecord(
          this.getRowProduct(product)
        );
        if (quantity > 0) {
          counts[product.id] = (counts[product.id] || 0) + 1;
        }
      });

      this.combinations.forEach((combo) => {
        combo.products.forEach((product) => {
          const quantity = this.getEffectiveQuantityByRecord(
            this.getComboProductRecord(product._comboProductId)
          );
          if (quantity > 0) {
            counts[product.product_id] = (counts[product.product_id] || 0) + 1;
          }
        });
      });

      return counts;
    },
  },
  methods: {
    confirmDelete(message, next) {
      this.$confirm({
        message,
        buttons: {
          left: {
            text: this.$t('DefenseCombinations:ConfirmDelete'),
            icon: 'delete',
          },
          right: {
            text: this.$t('DefenseCombinations:ConfirmCancel'),
            icon: 'cancel',
          },
        },
        callback: (confirm) => {
          if (confirm) next();
        },
      });
    },
    showConflictModal(productIds, isCombination, onConfirm) {
      this.conflictModal = {
        show: true,
        productNames: this.getSelectionConflictNames(productIds),
        isCombination,
        onConfirm,
      };
    },
    onConflictConfirm() {
      const callback = this.conflictModal.onConfirm;
      this.onConflictCancel();
      if (callback) callback();
    },
    onConflictCancel() {
      this.conflictModal = {
        show: false,
        productNames: [],
        isCombination: false,
        onConfirm: null,
      };
    },
    openComboAddModal(id) {
      this.activeCombinationId = id;
      this.showAddModal = true;
    },
    addCombination() {
      this.$store.commit(mutationTypes.addPestCombination, {
        program_phase_id: this.phase.id,
        pest_id: this.pest.id,
      });
    },
    removeCombination(id) {
      const combo = this.combinations.find((c) => c.id === id);
      const doRemove = () =>
        this.$store.commit(mutationTypes.removePestCombination, { id });

      if ((combo?.products?.length ?? 0) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteCombination'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    removeComboProduct(comboProductId) {
      const comboProduct = this.combinations
        .flatMap((c) => c.products || [])
        .find((p) => p._comboProductId === comboProductId);
      const doRemove = () =>
        this.$store.commit(mutationTypes.removePestCombinationProduct, {
          id: comboProductId,
        });

      if (this.getEffectiveQuantityByRecord(comboProduct) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteProduct'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    addProduct(productId) {
      if (!this.activeCombinationId) return;
      this.$store.commit(mutationTypes.addPestCombinationProduct, {
        combination_id: this.activeCombinationId,
        product_id: productId,
      });
      this.activeCombinationId = null;
      this.showAddModal = false;
    },
    getEffectiveQuantityByRecord(record) {
      return record?.current_quantity ?? record?.quantity ?? 0;
    },
    getRowProduct(product) {
      return this.programPestsProducts.find(
        (p) =>
          p.pest_id === this.pest.id &&
          p.product_id === product.id &&
          p.program_phase_id === this.phase.id
      );
    },
    getEffectiveQuantity(product) {
      return this.getEffectiveQuantityByRecord(this.getRowProduct(product));
    },
    getSelectionConflictNames(productIds) {
      return [...new Set(productIds)]
        .map((id) => this.plantsCareProductsAsMap[id]?.name)
        .filter(Boolean);
    },
    replaceSelectionWithProduct(product, conflicts) {
      conflicts.combinationIds.forEach((id) => {
        this.$store.commit(mutationTypes.setSelectedCombination, {
          id,
          forStimulationType: false,
        });
      });
      conflicts.productIds.forEach((productId) => {
        this.$store.commit(mutationTypes.setSelectedProduct, {
          product_id: productId,
          object_id: this.pest.id,
          program_phase_id: this.phase.id,
        });
      });
      this.$store.commit(mutationTypes.setSelectedProduct, {
        product_id: product.id,
        object_id: this.pest.id,
        program_phase_id: this.phase.id,
      });
    },
    replaceSelectionWithCombination(combo, conflicts) {
      conflicts.combinationIds.forEach((id) => {
        this.$store.commit(mutationTypes.setSelectedCombination, {
          id,
          forStimulationType: false,
        });
      });
      conflicts.productIds.forEach((productId) => {
        this.$store.commit(mutationTypes.setSelectedProduct, {
          product_id: productId,
          object_id: this.pest.id,
          program_phase_id: this.phase.id,
        });
      });
      this.$store.commit(mutationTypes.setSelectedCombination, {
        id: combo.id,
        forStimulationType: false,
      });
    },
    isTempProductPristine(product) {
      const rowProduct = this.getRowProduct(product);
      return (
        this.phase.is_temporary &&
        rowProduct &&
        rowProduct.quantity === null &&
        rowProduct.current_quantity === null
      );
    },
    getTempProductDisplayValue(product) {
      return this.isTempProductPristine(product)
        ? null
        : this.pestsProductsAsMap[product.id];
    },
    isTempProductQuantityBlocked(product) {
      if (!this.phase.is_temporary) return false;
      const rowProduct = this.getRowProduct(product);
      const currentQuantity = this.getEffectiveQuantityByRecord(rowProduct);
      if (currentQuantity > 0) return false;

      return Boolean(this.tempActiveProductCounts[product.id]);
    },
    isTempComboProductQuantityBlocked(comboProd) {
      if (!this.phase.is_temporary) return false;
      const currentQuantity = this.getEffectiveQuantityByRecord(
        this.getComboProductRecord(comboProd._comboProductId)
      );
      if (currentQuantity > 0) return false;

      return Boolean(this.tempActiveProductCounts[comboProd.product_id]);
    },
    getTempProductInputState(product) {
      if (this.isSaving) return 'disabled';
      return this.isTempProductQuantityBlocked(product) ? 'disabled' : '';
    },
    getTempComboProductInputState(comboProd) {
      if (this.isSaving) return 'disabled';
      return this.isTempComboProductQuantityBlocked(comboProd)
        ? 'disabled'
        : '';
    },
    getComboProductRecord(comboProductId) {
      return this.$store.state.userDefence.programPestsCombinationsProducts.find(
        (p) => p.id === comboProductId
      );
    },
    isTempComboProductPristine(comboProd) {
      const comboProduct = this.getComboProductRecord(
        comboProd._comboProductId
      );
      return (
        this.phase.is_temporary &&
        comboProduct &&
        comboProduct.quantity === null &&
        comboProduct.current_quantity === null
      );
    },
    getTempComboProductDisplayValue(comboProd) {
      return this.isTempComboProductPristine(comboProd)
        ? null
        : comboProd.quantity;
    },
    wasCombinationSelectedOnServer(comboId) {
      return Boolean(
        this.$store.state.userDefence.serverData.programPestsCombinations?.find(
          ({ id }) => id === comboId
        )?.is_selected
      );
    },
    shouldShowCombination(combo) {
      const hasInactiveProduct = combo.products.some(
        (product) => product.is_active === 0
      );
      if (!hasInactiveProduct) return true;
      return combo.is_selected || this.wasCombinationSelectedOnServer(combo.id);
    },
    getComboTemplateQuantity(comboProductId) {
      return this.getComboProductRecord(comboProductId)?.quantity ?? '';
    },
    getTemplateQuantity(product) {
      return this.getRowProduct(product)?.quantity ?? '';
    },
    hasQuantityOverride(product) {
      const rowProduct = this.getRowProduct(product);
      if (!rowProduct) return false;
      return (
        rowProduct.current_quantity !== null &&
        rowProduct.current_quantity !== undefined &&
        rowProduct.current_quantity !== rowProduct.quantity
      );
    },
    hasComboQuantityOverride(comboProductId) {
      const comboProduct = this.getComboProductRecord(comboProductId);
      if (!comboProduct) return false;
      return (
        comboProduct.current_quantity !== null &&
        comboProduct.current_quantity !== undefined &&
        comboProduct.current_quantity !== comboProduct.quantity
      );
    },
    getSelectedState(product) {
      return this.getRowProduct(product)?.is_selected ?? 0;
    },
    calcProductNameStyle(product, isCombo = false, comboSelected = false) {
      const style = {};
      const selected = isCombo ? comboSelected : this.getSelectedState(product);
      style.cursor = this.phase.is_temporary ? 'auto' : 'pointer';
      if (!selected) style.color = '#a8a9ad';
      return style;
    },
    onInput(product, value) {
      if (this.isTempProductQuantityBlocked(product)) return;
      this.$store.commit(mutationTypes.setPestProductQuantity, {
        program_phase_id: this.phase.id,
        pest_id: this.pest.id,
        product_id: product.id,
        quantity: value,
      });
    },
    onChange(product) {
      if (this.phase.is_temporary) return;
      if (this.getSelectedState(product)) {
        this.$store.commit(mutationTypes.setSelectedProduct, {
          product_id: product.id,
          object_id: this.pest.id,
          program_phase_id: this.phase.id,
        });
        return;
      }
      const conflicts = this.udGetProgramProductSelectionConflicts({
        product_id: product.id,
        object_id: this.pest.id,
        program_phase_id: this.phase.id,
      });
      if (conflicts.productIds.length || conflicts.combinationIds.length) {
        this.showConflictModal(conflicts.conflictedProductIds, false, () =>
          this.replaceSelectionWithProduct(product, conflicts)
        );
        return;
      }
      this.$store.commit(mutationTypes.setSelectedProduct, {
        product_id: product.id,
        object_id: this.pest.id,
        program_phase_id: this.phase.id,
      });
    },
    onComboChange(combo) {
      if (this.phase.is_temporary) return;
      if (combo.is_selected) {
        this.$store.commit(mutationTypes.setSelectedCombination, {
          id: combo.id,
          forStimulationType: false,
        });
        return;
      }
      const conflicts = this.udGetProgramCombinationSelectionConflicts({
        id: combo.id,
        object_id: this.pest.id,
        program_phase_id: this.phase.id,
      });
      if (conflicts.productIds.length || conflicts.combinationIds.length) {
        this.showConflictModal(conflicts.conflictedProductIds, true, () =>
          this.replaceSelectionWithCombination(combo, conflicts)
        );
        return;
      }
      this.$store.commit(mutationTypes.setSelectedCombination, {
        id: combo.id,
        forStimulationType: false,
      });
    },
    onComboProductInput(comboProductId, value) {
      const comboProduct = this.combinations
        .flatMap((combo) => combo.products)
        .find((product) => product._comboProductId === comboProductId);
      if (
        comboProduct &&
        this.isTempComboProductQuantityBlocked(comboProduct)
      ) {
        return;
      }
      this.$store.commit(mutationTypes.setPestCombinationProductQuantity, {
        id: comboProductId,
        quantity: value,
      });
    },
    updateComboComment(id, comment) {
      this.$store.commit(mutationTypes.updatePestCombinationComment, {
        id,
        comment,
      });
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/vars.scss';

#force-red {
  height: 24px;
  width: 24px;
  min-width: 24px;
  padding: 1px;

  & svg {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 1800px) {
  #force-red {
    height: 24px * $k1600;
    width: 24px * $k1600;
    min-width: 24px * $k1600;
  }
}

@media screen and (max-width: 1420px) {
  #force-red {
    height: 24px * $k1360;
    width: 24px * $k1360;
    min-width: 24px * $k1360;
  }
}

.quantity-old {
  font-size: 12px;
  color: $colorGray;
}

.quantity-display {
  text-align: right;
  padding: 0 6px;
}

.quantity-display--override {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.quantity-current {
  margin-left: auto;
  padding-right: 2px;
}

.tbl-cellinpt {
  padding: 0 !important;
}

.cellproblem-inner {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.row--combination-spacer {
  height: 12px;
  padding: 0;
  border: none;
}

.combination-header-cell {
  padding-left: 0;

  label {
    display: none;
  }

  .tbl_info {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .tbl_info-wrap {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex: 1 1 auto;
  }

  .inputintable {
    flex-grow: 1 !important;
    width: 100% !important;
    margin-left: 0 !important;
    padding: 4px !important;
    box-sizing: border-box;
    min-width: auto;
  }
}

.combination-header-delete {
  width: 18px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
}

.combination-header-delete .vsvg-auto,
.combination-header-delete .svg-icon {
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
}

.combination-inline-delete {
  margin-left: auto;
  width: 18px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.combination-inline-delete .vsvg-auto,
.combination-inline-delete .svg-icon {
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
}

.table--defense {
  .row--combination {
    .tablepreview {
      top: auto !important;
      bottom: 100% !important;
      left: 0% !important;
      right: auto;
    }

    .tbl-cellproduct {
      .tbl_info-celltext {
        width: auto !important;
      }
    }
  }

  .tbl-cellproduct {
    padding-left: 25px;

    .tbl_info-wrap {
      display: flex;
      gap: $marginMicro;
    }
  }
}

.temp-input--pristine {
  opacity: 0.58;
}

.temp-input--pristine :deep(.inpt) {
  color: #a8a9ad;
}

.temp-input--pristine :deep(.inptwrap) {
  background: rgba(237, 242, 228, 0.42);
}

@media screen and (max-width: 1800px) {
  .table--defense {
    .tbl-cellproduct {
      padding-left: 20px;

      & .tbl_info-wrap {
        gap: $marginMicro-k1600;
      }
    }
  }
}

@media screen and (max-width: 1420px) {
  .table--defense {
    .row--combination {
      .tbl_info-wrap {
        display: flex;
      }
    }

    .tbl-cellproduct {
      padding-left: 17px;

      & .tbl_info-wrap {
        gap: $marginMicro-k1360;
      }
    }
  }
}
</style>
